import { render, staticRenderFns } from "./AddComparisonItemComponent.vue?vue&type=template&id=6eb11d8e&scoped=true"
import script from "./AddComparisonItemComponent.vue?vue&type=script&lang=ts"
export * from "./AddComparisonItemComponent.vue?vue&type=script&lang=ts"
import style0 from "./AddComparisonItemComponent.vue?vue&type=style&index=0&id=6eb11d8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb11d8e",
  null
  
)

export default component.exports